import en from './en';
import ru from './ru';

export default { en, ru } as {
  en: typeof en;
  ru: typeof ru;
};
